import { render } from "./AssetSelect.vue?vue&type=template&id=4a2a4674&scoped=true"
import script from "./AssetSelect.vue?vue&type=script&lang=js"
export * from "./AssetSelect.vue?vue&type=script&lang=js"

import "./AssetSelect.vue?vue&type=style&index=0&id=4a2a4674&scoped=true&lang=scss"
import "./AssetSelect.vue?vue&type=style&index=1&id=4a2a4674&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a2a4674"]])

export default __exports__